import { render, staticRenderFns } from "./Basico.vue?vue&type=template&id=75c3d6f8&scoped=true"
import script from "./Basico.vue?vue&type=script&lang=js"
export * from "./Basico.vue?vue&type=script&lang=js"
import style0 from "./Basico.vue?vue&type=style&index=0&id=75c3d6f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c3d6f8",
  null
  
)

export default component.exports